var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "start-page-portfolios-carousel" },
    [
      _setup.props.showTitle
        ? _c("h3", {
            staticClass: "h2",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.start.portfolios_carousel.title", {
                  count: _setup.props.portfoliosCount,
                })
              ),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? [_vm._m(0)]
        : [
            _vm.portfoliosCount > 0
              ? [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row align-items-center mb-3" },
                    [
                      _c("div", {
                        staticClass: "flex-grow-1 text-muted",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "ui.components.start.portfolios_carousel.description"
                            )
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-none d-md-block" },
                        [
                          _c(_setup.CiButton, {
                            attrs: {
                              variant: "filled-primary",
                              label: _vm.$t(
                                "ui.components.start.portfolios_carousel.button"
                              ),
                              to: { name: _vm.$routes.PORTFOLIOS_INDEX },
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _setup.emit("tracking-click", {
                                  targetName: "ButtonMyPortfolios",
                                  sourceName: "Products",
                                })
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(_setup.ScrollSnapSlider, {
                    attrs: {
                      id: "portfolios-list",
                      items: _vm.portfolios,
                      "optional-item": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ item, index }) {
                            return [
                              _c(_setup.PortfolioTile, {
                                key: index,
                                attrs: {
                                  portfolio: item,
                                  "with-border": true,
                                  variant: "start-page",
                                },
                                on: {
                                  "tracking-click": _setup.propagateTrackClick,
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: "optionalItem",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ci-card with-border with-hover d-flex flex-row align-items-center p-4",
                                  attrs: { id: "portfolios-cta" },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("p", {
                                        staticClass: "text-center",
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "ui.components.start.portfolios_carousel.cta.description"
                                            )
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(_setup.CiButton, {
                                        staticClass: "w-100",
                                        attrs: {
                                          variant: "outline-primary",
                                          icon: "mdi-plus",
                                          label: _vm.$t(
                                            "ui.components.start.portfolios_carousel.cta.button"
                                          ),
                                          to: {
                                            name: _vm.$routes.PORTFOLIOS_INDEX,
                                            query: {
                                              modal: "create_portfolio",
                                            },
                                          },
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _setup.emit(
                                              "tracking-click",
                                              {
                                                targetName:
                                                  "ButtonCreatePortfolio",
                                                sourceName: "Products",
                                              }
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      897513526
                    ),
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-md-none mt-3" },
                    [
                      _c(_setup.CiButton, {
                        staticClass: "w-100",
                        attrs: {
                          variant: "filled-primary",
                          label: _vm.$t(
                            "ui.components.start.portfolios_carousel.button"
                          ),
                          to: { name: _vm.$routes.PORTFOLIOS_INDEX },
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _setup.emit("tracking-click", {
                              targetName: "ButtonMyPortfolios",
                              sourceName: "Products",
                            })
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : [
                  _c(_setup.DepotUploadModal),
                  _vm._v(" "),
                  _c(_setup.CiEmptystate, {
                    attrs: {
                      "image-type": "portfoliosUser",
                      "locale-path": "portfolios.user",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex flex-row mb-4" }, [
                    _c(
                      "div",
                      { staticClass: "mx-auto" },
                      [
                        _c(_setup.CiButton, {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal",
                              value: _vm.$bvModalList.ids.DEPOT_UPLOAD,
                              expression: "$bvModalList.ids.DEPOT_UPLOAD",
                            },
                          ],
                          attrs: {
                            variant: "outline-primary",
                            label: _vm.$t(
                              "ui.components.start.portfolios_carousel.emptystate.button.depot_upload"
                            ),
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _setup.emit("tracking-click", {
                                targetName: "ButtonUploadDepot",
                                sourceName: "Products",
                              })
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(_setup.CiButton, {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal",
                              value:
                                _vm.$bvModalList.ids
                                  .PORTFOLIOS_CREATE_WITH_PRODUCTS,
                              expression:
                                "$bvModalList.ids.PORTFOLIOS_CREATE_WITH_PRODUCTS",
                            },
                          ],
                          staticClass: "ml-4",
                          attrs: {
                            variant: "filled-primary",
                            icon: "mdi-plus",
                            label: _vm.$t(
                              "ui.components.start.portfolios_carousel.emptystate.button.new_portfolio"
                            ),
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _setup.emit("tracking-click", {
                                targetName: "ButtonCreatePortfolio",
                                sourceName: "Products",
                              })
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "loading-spinner d-flex flex-column" }, [
      _c("div", {
        staticClass:
          "d-flex justify-content-center mdi mdi-loading mdi-spin h1 my-auto",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }